export default "__VITE_ASSET__C_zNB_Tr__"